import { MFELoggerAndReactErrorBoundary } from '@wf-mfe/logger'

export const { logger, ErrorBoundary } = MFELoggerAndReactErrorBoundary({
  name: 'notification-hub',
})
